/**
 * Caches a measure and calculate it only if an element used to calculate it is changed.
 */
export class CachedMeasure {
    constructor(_formula, ...objs) {
        this._formula = _formula;
        this.isCachedMeasure = true;
        this.needUpdate = true;
        this._callbacks = [];
        this._objs = objs;
        for (const obj of objs) {
            this._callbacks.push(obj.bindEvent("onPositionComponentChange", () => { this.needUpdate = true; }));
        }
    }
    /**
     * Get the value obtained from the formula.
     */
    get value() {
        if (this.needUpdate) {
            this.needUpdate = false;
            return this._value = this._formula();
        }
        else {
            return this._value;
        }
    }
    /**
     * Remove all events binded to every element used by the formula.
     */
    dispose() {
        for (let i = 0; i < this._objs.length; i++) {
            this._objs[i].unbindEvent("onPositionComponentChange", this._callbacks[i]);
        }
    }
}
//# sourceMappingURL=CachedMeasure.js.map